import React, { useCallback } from 'react';
import { FormControl, FormHelperText } from '@mui/material';
import { AddressElement } from '@stripe/react-stripe-js';
import type { StripeAddressElementChangeEvent } from '@stripe/stripe-js';

import type { StripeAddresssFieldProps } from './types';

import classes from './stripe-address-field.module.css';

export const StripeAddresssField: React.FC<StripeAddresssFieldProps> = ({
  error,
  onChange,
}) => {
  const handleAddressChange = useCallback(
    (event: StripeAddressElementChangeEvent) => {
      onChange(event.value);
    },
    [onChange]
  );

  return (
    <FormControl error={!!error} fullWidth>
      <div className={classes['address-container']}>
        <AddressElement
          onChange={handleAddressChange}
          options={{
            mode: 'billing',
          }}
        />
      </div>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
